// src/routes/AppRouter.jsx
import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../layouts/RootLayout";
import Dashboard from "../pages/Dashboard";
import FilesManager from "../pages/FilesManager";
import Templates from "../pages/Templates";
import FileDetails from "../pages/FilesManager/FileDetails";
import Login from "../pages/Auth/Login";
import Signup from "../pages/Auth/Signup";
import ProtectedRoute from "./ProtectedRoute";
import ErrorScreen from "../pages/ErrorScreen"; // Import your error page
import CustomerRooms from "../pages/CustomerRooms";
import Profile from "../pages/Profile";
import ReactFlowScreen from "../pages/ReactFlowScreen";
import Messages from "../pages/Messages";
import Notes from "../pages/notes";
import Tasks from "../pages/Tasks";
import TasksDashboard from "../pages/TasksDashboard";
import ManageTeams from "../pages/ManageTeams";

const router = createBrowserRouter(
  [
    { path: "/login", element: <Login /> },
    { path: "/signup", element: <Signup /> },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <RootLayout />
        </ProtectedRoute>
      ),
      children: [
        { path: "/", element: <Dashboard /> },
        { path: "/files-manager", element: <FilesManager /> },
        { path: "/files-manager/:id", element: <FileDetails /> },
        { path: "/templates", element: <Templates /> },
        { path: "/customer-rooms", element: <CustomerRooms /> },
        { path: "/profile",element: <Profile />},
          { path: "/templates/:id", element: <ReactFlowScreen /> },
          { path: "/messages", element: <Messages /> },
          {path:"/notes",element: <Notes/>},
          {path:"/tasks",element: <Tasks/>},
          {path:"/tasks-dashboard",element: <TasksDashboard/>},
          {path:"/manage-teams",element: <ManageTeams/>},
    
      ],
    },
    {
      path: "*", // Catch-all route for 404 pages
      element: <ErrorScreen />,
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
      v7_startTransition: true, // Add this flag
      
    },
  }
);

export default router;
